<template>
<!-- 监控组件 -->
  <el-dialog title="监控" :visible.sync="dialog" :fullscreen="true" @close="closeDialog" :close-on-click-modal="false" width="90%" center>
    <el-form :inline="true" ref="ZBform"  :model="ZBform"
     class="demo-form-inline jiaoyan" label-width="100px" size="mini">
      <div class="QDtiem">
          <!-- <div>
            <el-form-item label="航次号:"   prop="">
               <span>{{rowData.shipDateNo}}</span>
            </el-form-item>
            <el-form-item label="起始码头:"   prop="">
               <span>{{ZBform.deliverName}}</span>
            </el-form-item>
            <el-form-item label="目的码头:"   prop="">
               <span>{{ZBform.receivingName}}</span>
            </el-form-item>
            <el-form-item label="最后监控时间:" prop="shipMentTime">
               {{ZBform.lastTime|dateFormat}}
          </el-form-item>
          </div> -->
          <div class="zuobiaoBox">
            <coordinate :row-data="rowData" v-if="dialog" @gengxin="gengxin"></coordinate>
          </div>
          <div class="mapBox">
             <el-amap
             ref="map"
            vid="vueMap"
            :zoom="12"
            class="amap-demo"
            :events="events"
            complete="complete"
            >
            <el-amap-marker v-for="(marker, index) in markers" :key="index" :position="marker.position"
             :title="marker.title" :visible="true"  :vid="index"></el-amap-marker>
             <!-- <el-amap-polyline   :path="path1" strokeColor="#3366dd" strokeWeight="5" strokeStyle="dashed" v-if="this.rowData.shipStatus==2" ></el-amap-polyline> -->
          </el-amap>
          </div>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialog = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { shipCoordinateList, getShipDateAddress } from '@/api/shipping'
import coordinate from '@/views/shipping/shipingBill/coordinate.vue'
export default {
  name: 'monitorMap',
  components: {
    coordinate
  },
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    let that = this
    return {
      dialog: false,
      ZBform: {},
      ZBList: [],
      markers: [],
      path: [],
      path1: [], // 虚线
      events: {
        complete () {
          shipCoordinateList({ shipDateId: that.rowData.id }).then(res => {
            getShipDateAddress({ shipDateId: that.rowData.id }).then(res1 => {
              that.markers.push(
                {
                  'title': res1.deliverAddressList[0].addressName,
                  'position': [res1.deliverAddressList[0].longitude, res1.deliverAddressList[0].latitude]
                }
              )
              res1.receiveAddressList.forEach(item => {
                that.markers.push({
                  'title': item.addressName,
                  'position': [item.longitude, item.latitude]
                })
              })
              console.log(that.markers)
              that.complete(res)
            })
          })
        }
      }

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.ZBform.shipDateId = this.rowData.id
    this.dialog = true
  },
  methods: {
    complete (res) {
      let that = this
      // if (res.list.length > 0) {
      //   let lastZB = res.list[res.list.length - 1]
      //   that.ZBform.lastTime = lastZB.coordinateTime
      // }
      // that.markers.push({
      //   'position': [that.ZBform.receivingLon, that.ZBform.receivingLat],
      //   'title': that.ZBform.receivingName

      // })
      // that.markers.push({
      //   'position': [that.ZBform.deliverLon, that.ZBform.deliverLat],
      //   'title': that.ZBform.deliverName
      // })
      that.path = []
      that.path.push(that.markers[0].position)
      res.list.reverse().forEach(item => {
        that.path.push([item.longitude, item.latitude])
      })
      // if (that.rowData.shipStatus == 2) {
      //   that.path1.push([res.list[res.list.length - 1].longitude, res.list[res.list.length - 1].latitude])
      //   that.path1.push([res.receivingLon, res.receivingLat])
      // }

      that.$nextTick(() => {
        let polyline = that.$refs.map.$$getInstance().getAllOverlays('polyline')
        that.$refs.map.$$getInstance().remove(polyline)
        if (that.path.length > 0) {
          var polyline4 = new AMap.Polyline({
            path: that.path, // 设置线覆盖物路径
            showDir: true,
            strokeColor: '#3366dd', // 线颜色
            strokeWeight: 5 // 线宽
          })
          // that.$refs.map.$$getInstance().add(polyline4)
          polyline4.setMap(that.$refs.map.$$getInstance())
        }
        console.log(that.path)
        let data = that.$refs.map.$$getInstance().getAllOverlays('marker')
        that.$refs.map.$$getInstance().setFitView(data)
      })
    },
    gengxin (res) {
      this.complete(res)
    },
    closeDialog () {
      this.$emit('destroy')
    }
  },
  destroyed () {
    this.dialog = false
  }
}
</script>

<style scoped lang='less'>
.el-vue-amap-container{
  height:90vh;
}
.QDtiem{
 /deep/.el-date-editor .el-input__inner{
   border:none;
   padding: 0;
  position: relative;
 }
 .zuobiaoBox{
       position: absolute;
    width: 400px;
    z-index: 999999;
    background: #fff;
     height:90vh;
 }
  /deep/.el-input__icon {
  display: none;
 }
}
/deep/.el-dialog .el-dialog__body{
  padding:0;
}
</style>
